import { Permission } from '@traton/devportal-rbac-common-lib';

export const announcementReadPermission: Permission = {
  name: 'announcement.read',
  description: 'Allows reading announcements',
};

export const announcementCreatePermission: Permission = {
  name: 'announcement.create',
  description: 'Allows creating announcements',
};

export const announcementUpdatePermission: Permission = {
  name: 'announcement.update',
  description: 'Allows updating announcements',
};

export const announcementDeletePermission: Permission = {
  name: 'announcement.delete',
  description: 'Allows deleting announcements',
};
